import React from 'react'
import { LogoMasterClassMonogram } from '@mc/educator-design-system'

interface HeaderProps {
  onClose?: () => void
}

export const Header = ({ onClose }: HeaderProps) => (
  <header className='flex items-center justify-between absolute top-0 left-0 right-0 py-3 pl-5 pr-4'>
    <div className='flex items-center gap-2'>
      <div className='w-11 h-11 flex items-center justify-center text-text-primary'>
        <LogoMasterClassMonogram
          width={44}
          height={44}
          className='text-black'
        />
      </div>
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <span className='font-sans text-[15.565px] tracking-[1.4px] uppercase text-text-primary'>
        Executive
      </span>
    </div>
    {onClose && (
      <button
        onClick={onClose}
        className='w-8 h-8 flex items-center justify-center bg-transparent border-none cursor-pointer text-text-primary p-0 hover:opacity-70'
        aria-label='Close'
        type='button'
      >
        <svg
          width='32'
          height='32'
          viewBox='0 0 32 32'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M24 8L8 24M8 8L24 24'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </button>
    )}
  </header>
)
